export class Agents {
    constructor() {
        const agentButtons = document.querySelectorAll('.property-agents__agent-button');

        agentButtons.forEach(button => {
            button.addEventListener('click', () => {
                const content = button.parentNode.querySelector('.property-agents__agent-content');
                content.classList.toggle('is-active');
                button.classList.toggle('is-active');
            });
        });
    }
}